import React, { useState } from "react";
import ModalStructure from "../../ModalStructure";
import { MdDeleteForever } from "react-icons/md";
import { IoIosAdd, IoIosClose } from "react-icons/io";

const SpecsModal = ({
  handleCloseModal,
  _data,
  editable,
  subClass,
  loadToParent,
  handleClose,
}) => {
  const [data, setData] = useState({
    mainSpecs: editable ? subClass.mainSpecs || [] : _data.mainSpecs || [],
    otherSpecs: _data?.otherSpecs || [],
  });

  // Función auxiliar para inicializar selectedValues basado en _data
  const initializeSelectedValues = () => {
    if (!_data) return {};
    if (!editable) return {};
    const initialSelections = {};
    subClass.mainSpecs.forEach((spec, mainIndex) => {
      spec.values.forEach((_, valueIndex) => {
        if (
          _data.mainSpecs.some(
            (mainSpec) =>
              mainSpec.name == spec.name &&
              mainSpec.values.some(
                (val) =>
                  val.value == spec.values[valueIndex].value &&
                  val.code == spec.values[valueIndex].code
              )
          )
        ) {
          initialSelections[`${mainIndex}-${valueIndex}`] = true;
        }
      });
    });
    return initialSelections;
  };

  // Inicializamos selectedValues con los valores de _data
  const [selectedValues, setSelectedValues] = useState(
    initializeSelectedValues()
  );

  // Manejar cambio en checkbox
  const handleCheckboxChange = (mainSpecIndex, valueIndex) => {
    setSelectedValues((prev) => {
      const key = `${mainSpecIndex}-${valueIndex}`;
      return {
        ...prev,
        [key]: !prev[key],
      };
    });
  };

  // Verificar si un valor está seleccionado
  const isValueSelected = (mainSpecIndex, valueIndex) => {
    return selectedValues[`${mainSpecIndex}-${valueIndex}`] || false;
  };

  const canAddMainSpec = () => {
    // Validar que el último mainSpec tenga un nombre y al menos un valor
    if (data.mainSpecs.length === 0) return true;

    const lastMainSpec = data.mainSpecs[data.mainSpecs.length - 1];
    return lastMainSpec.name.trim() !== "" && lastMainSpec.values.length > 0;
  };
  // Validar si se puede agregar un nuevo other spec
  const canAddOtherSpec = () => {
    if (data.otherSpecs.length === 0) return true;

    const lastSpec = data.otherSpecs[data.otherSpecs.length - 1];
    return lastSpec.name.trim() !== "" && lastSpec.value.trim() !== "";
  };

  // Actualizar valor de other spec
  const handleOtherSpecChange = (index, field, value) => {
    setData((prev) => {
      const updatedOtherSpecs = [...prev.otherSpecs];
      updatedOtherSpecs[index] = {
        ...updatedOtherSpecs[index],
        [field]: value,
      };
      return { ...prev, otherSpecs: updatedOtherSpecs };
    });
  };

  // Agregar mainSpec solo si está permitido
  const onClickAddMainSpec = () => {
    //if (!canModifyMainSpecs) return;
    setData((prev) => ({
      ...prev,
      mainSpecs: [...prev.mainSpecs, { name: "", values: [] }],
    }));
  };

  // Eliminar un mainSpec si no tiene ID
  const onClickDeleteMainSpec = (index) => {
    const mainSpec = data.mainSpecs[index];
    if (mainSpec.id) return; // No eliminar si tiene un ID

    setData((prev) => {
      const updatedMainSpecs = [...prev.mainSpecs];
      updatedMainSpecs.splice(index, 1);
      return { ...prev, mainSpecs: updatedMainSpecs };
    });
  };

  // Manejar cambios en el nombre del mainSpec
  const handleMainSpecNameChange = (index, newName) => {
    setData((prev) => {
      const updatedMainSpecs = [...prev.mainSpecs];
      updatedMainSpecs[index].name = newName;
      return { ...prev, mainSpecs: updatedMainSpecs };
    });
  };

  // Agregar valor a un mainSpec
  const onClickAddMainSpecValue = (index, newValue, newCode) => {
    if (!newValue.trim() || !newCode.trim()) return;
    setData((prev) => {
      const updatedMainSpecs = [...prev.mainSpecs];
      updatedMainSpecs[index].values.push({ value: newValue, code: newCode });
      return { ...prev, mainSpecs: updatedMainSpecs };
    });
  };

  // Eliminar un valor dentro de mainSpecs
  const onClickDeleteMainSpecValue = (mainIndex, valueIndex) => {
    setData((prev) => {
      const updatedMainSpecs = [...prev.mainSpecs];
      updatedMainSpecs[mainIndex].values.splice(valueIndex, 1);
      return { ...prev, mainSpecs: updatedMainSpecs };
    });
  };

  // Eliminar otra especificación
  const onClickDeleteOtherSpec = (index) => {
    setData((prev) => {
      const updatedOtherSpecs = [...prev.otherSpecs];
      updatedOtherSpecs.splice(index, 1);
      return { ...prev, otherSpecs: updatedOtherSpecs };
    });
  };

  // Agregar otra especificación
  const onClickAddOtherSpec = () => {
    if (!canAddOtherSpec()) return;

    setData((prev) => ({
      ...prev,
      otherSpecs: [...prev.otherSpecs, { name: "", value: "" }],
    }));
  };

  // Determinar si un mainSpec puede eliminarse
  const canDeleteMainSpecValue = (i, j) => {
    const currentValue = data.mainSpecs[i]?.values[j];
    return !currentValue?.id;
  };

  // Limpiar y preparar data para guardar
  const handleSave = () => {
    const cleanData = {
      mainSpecs: data.mainSpecs.reduce((acc, spec, mainIndex) => {
        // Filtrar solo los valores seleccionados de este mainSpec
        const selectedSpecValues = spec.values.filter((_, valueIndex) =>
          isValueSelected(mainIndex, valueIndex)
        );
        // .map((val) => ({
        //   value: val.value,
        //   code: val.code,
        // }));

        // Solo incluir el mainSpec si tiene valores seleccionados
        if (selectedSpecValues.length > 0) {
          acc.push({
            name: spec.name,
            values: selectedSpecValues,
          });
        }

        return acc;
      }, []),
      otherSpecs: data.otherSpecs.filter(
        (spec) => spec.name.trim() !== "" && spec.value.trim() !== ""
      ),
    };

    console.log("data a guardar: ", cleanData);
    loadToParent(cleanData); //falta limpiar ids
    handleClose();
  };

  return (
    <ModalStructure handleCloseModal={handleCloseModal}>
      <div className="flex flex-col p-4 font-poppins items-center w-full gap-y-2">
        <h3 className="text-lg font-bold px-4">
          Especificaciones Principales (Filtros)
        </h3>
        <div className="border-[1px] border-accent-green rounded-[10px] shadow-md w-full">
          {data.mainSpecs.map((spec, i) => (
            <div
              className={`flex ${
                editable ? "flex-col" : "flex-row items-center"
              } gap-y-2 px-4 py-2 ${
                i % 2 === 0 ? "bg-white" : "bg-light-green"
              } ${
                i == 0
                  ? "rounded-t-[10px]"
                  : i == data?.mainSpecs?.length - 1
                  ? "rounded-b-[10px]"
                  : ""
              }
              
              ${i == 0 && data.mainSpecs.length == 1 ? "rounded-b-[10px]" : ""}
              w-full`}
              key={i}
            >
              <div className="flex flex-row items-center gap-x-2 w-[50%]">
                {spec.id ? (
                  <span className="font-bold  px-4 py-2">{spec.name}</span>
                ) : (
                  <input
                    type="text"
                    value={spec.name}
                    onChange={(e) => {
                      handleMainSpecNameChange(i, e.target.value);
                    }}
                    placeholder="Nombre"
                    className="border p-1 rounded text-sm w-full"
                  />
                )}

                {editable && !spec.id && (
                  <button
                    className="bg-red-500 text-white p-1 rounded hover:bg-red-400"
                    onClick={() => onClickDeleteMainSpec(i)}
                  >
                    <MdDeleteForever />
                  </button>
                )}
              </div>
              {!editable && ":"}
              <div
                className={`flex ${
                  editable
                    ? "w-full flex-wrap justify-between items-center"
                    : "w-[50%] flex-row "
                }    gap-x-2  px-4`}
              >
                {spec.values.map((specValue, j) => (
                  <label key={j} className={`flex items-center gap-2`}>
                    <input
                      type="checkbox"
                      className={`${
                        editable ? "flex" : "hidden"
                      } cursor-pointer`}
                      checked={isValueSelected(i, j)}
                      onChange={() => handleCheckboxChange(i, j)}
                    />

                    <span>
                      {specValue.value} ({specValue.code})
                    </span>
                    {editable && !specValue.id && (
                      <button
                        className="ml-1 bg-red-500 text-white rounded p-[2px] hover:bg-red-400"
                        onClick={() => onClickDeleteMainSpecValue(i, j)}
                      >
                        <IoIosClose />
                      </button>
                    )}
                  </label>
                ))}
              </div>
              {editable && (
                <div className="flex items-center gap-2 py-2 px-4 w-full">
                  <input
                    type="text"
                    placeholder="Valor"
                    className="border p-1 rounded text-sm w-full"
                    id={`value-${i}`}
                  />
                  <input
                    type="text"
                    placeholder="Código"
                    className="border p-1 rounded text-sm w-full"
                    id={`code-${i}`}
                  />
                  <button
                    className="bg-green-500 text-white p-1 rounded hover:bg-green-400"
                    onClick={() => {
                      const valueInput = document.getElementById(`value-${i}`);
                      const codeInput = document.getElementById(`code-${i}`);
                      if (valueInput && codeInput) {
                        onClickAddMainSpecValue(
                          i,
                          valueInput.value,
                          codeInput.value
                        );
                        valueInput.value = "";
                        codeInput.value = "";
                      }
                    }}
                  >
                    <IoIosAdd />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
        {editable && canAddMainSpec() && (
          <button
            className="text-sm rounded-full p-1 hover:bg-light-gray"
            onClick={onClickAddMainSpec}
          >
            <IoIosAdd className="w-[20px] h-[20px]" />
          </button>
        )}

        <h3 className="text-lg font-bold px-4 mt-6">Otras especificaciones</h3>
        {data.otherSpecs.length > 0 && (
          <div className="border-[1px] border-accent-green rounded-[10px] shadow-md w-full">
            {data.otherSpecs.map((spec, i) => (
              <div
                className={`flex flex-col gap-y-2 px-4 py-2 
                
                ${i % 2 === 0 ? "bg-white" : "bg-light-green"} ${
                  i == 0
                    ? "rounded-t-[10px]"
                    : i == data?.otherSpecs?.length - 1
                    ? "rounded-b-[10px]"
                    : ""
                }
                ${
                  i == 0 && data.otherSpecs.length == 1
                    ? "rounded-b-[10px]"
                    : ""
                }
                `}
                key={i}
              >
                <div className="flex flex-row items-center gap-x-2 w-full">
                  <input
                    type="text"
                    value={spec.name}
                    onChange={(e) =>
                      handleOtherSpecChange(i, "name", e.target.value)
                    }
                    disabled={!editable}
                    className={`px-2 py-1 rounded-[5px] font-bold w-full ${
                      editable ? "bg-white" : "border-none bg-transparent"
                    }`}
                    placeholder="Nombre"
                  />
                  {" : "}
                  <input
                    type="text"
                    value={spec.value}
                    onChange={(e) =>
                      handleOtherSpecChange(i, "value", e.target.value)
                    }
                    disabled={!editable}
                    className={`px-2 py-1 rounded-[5px] w-full ${
                      editable ? "bg-white" : "border-none bg-transparent"
                    }`}
                    placeholder="Valor"
                  />
                  {editable && (
                    <button
                      className="bg-red-500 text-white rounded p-1 hover:bg-red-400"
                      onClick={() => onClickDeleteOtherSpec(i)}
                    >
                      <MdDeleteForever />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
        {editable && canAddOtherSpec() && (
          <button
            className="text-sm rounded-full p-1 hover:bg-light-gray"
            onClick={onClickAddOtherSpec}
          >
            <IoIosAdd className="w-[20px] h-[20px]" />
          </button>
        )}
      </div>

      {editable && (
        <div className="flex flex-row gap-x-2 items-center">
          <button
            className="font-poppins w-fit bg-dark-green text-base mt-4 mx-1 rounded-full py-2 px-4 text-white hover:bg-accent-green font-bold"
            onClick={handleSave}
          >
            Guardar
          </button>
        </div>
      )}
    </ModalStructure>
  );
};

export default SpecsModal;
